import MeetingTable from "./MeetingTable.container.view";

export default MeetingTable;
